
<div class="features">

    <div class="feature-group">
        <div class="feature-desktop">
            <div class="label">
                Title
            </div>
            <div class="text" *ngIf="data.title != ''  && data.title != undefined">
                {{item.title}}
            </div>
            <div class="value" *ngIf="data.title == '' || data.title == undefined">
                <input tabindex="1" [(ngModel)]="item.title" (blur)="save()" placeholder="Text" matInput aria-label="field-text">
            </div>
            <div class="action" *ngIf="data.title != ''  && data.title != undefined">
                <button [tabindex]="-1" (click)="updateTitle()" mat-button><mat-icon>refresh</mat-icon></button>
            </div>
        </div>

        <div class="feature-mobile" *ngIf="!isTitleDynamic()">
            <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput placeholder="" [(ngModel)]="item.title" (blur)="save()">
            </mat-form-field>
        </div>
    </div>

    <div *ngFor="let feature of featuresList;let i = index;">

        <ng-container [ngSwitch]="feature.type">
            <ng-container *ngSwitchCase="'select'">
                <div class="feature-desktop">
                    <div class="label">
                        {{feature.label}}
                    </div>
                    <div class="text">
                        <mat-select
                        no-space 
                        [hasBackdrop]="false"
                        [CdkConnectedOverlay]=""
                        [tabindex]="i+2" 
                        [value]="getFeatureValue(feature.label)" 
                        (selectionChange)="saveFeatureText(feature.label, $event.value)"
                        [placeholder]="(getFeatureValue(feature.label)=='') ? 'Select' : getFeatureValue(feature.label)">
                            <input placeholder="Text" (blur)="saveFeatureText(feature.label, $event.target.value, $event)" matInput aria-label="field-text">
                            <mat-option *ngFor="let option of feature.options" [value]='option'>{{option}}</mat-option>
                        </mat-select>
                    </div>
                </div>

                <div class="feature-mobile">
                    <mat-form-field appearance="outline" (click)="openFeatureSelectDialog(feature.label, getFeatureValue(feature.label), feature.options)">
                        <input matInput [placeholder]="feature.label" [value]="getFeatureValue(feature.label)">
                        <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    </mat-form-field>

                    <!-- <mat-form-field appearance="outline">
                        <mat-label>{{feature.label}}</mat-label>
                        <mat-select
                        [tabindex]="i+2" 
                        [value]="getFeatureValue(feature.label)" 
                        (selectionChange)="saveFeatureText(feature.label, $event.value)" 
                        [placeholder]="(getFeatureValue(feature.label)=='') ? 'Select' : getFeatureValue(feature.label)">
                            <input (click)="$event.target.value=''" placeholder="Text" (blur)="saveFeatureText(feature.label, $event.target.value)" matInput aria-label="field-text">
                            <mat-option *ngFor="let option of feature.options" [value]='option'>{{option}}</mat-option>
                        </mat-select>
                    </mat-form-field> -->
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'custom'">
                <div class="feature-desktop">
                    <div class="custom-label">
                        <input tabindex="-1"  placeholder="Label" [value]="feature.label" (blur)="saveCustomFeatureLabel(feature.label, $event.target.value)" matInput aria-label="field-label">
                    </div>
                    <div class="value">
                        <input [tabindex]="i+2" placeholder="Text" [value]="getFeatureValue(feature.label)" (blur)="saveFeatureText(feature.label, $event.target.value)" matInput aria-label="field-text">
                    </div>
                    <div class="action">
                        <button [tabindex]="-1"  (click)="deleteFeature(feature.label)" mat-button><mat-icon>delete</mat-icon></button>
                    </div>
                </div>

                <div class="feature-mobile">
                    <div class="fieldset mobile">
                        <mat-form-field appearance="outline">
                            <mat-label>{{feature.label}}</mat-label>
                            <input matInput [value]="getFeatureValue(feature.label)" (blur)="saveFeatureText(feature.label, $event.target.value)">
                            <button mat-icon-button matSuffix (click)="editFeature(feature)">
                                <mat-icon>more_vert</mat-icon>
                              </button>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                <div class="feature-desktop">
                    <div class="label">
                        {{feature.label}}
                    </div>
                    <div class="value">
                        <input [tabindex]="i+2" placeholder="Text" [value]="getFeatureValue(feature.label)" (blur)="saveFeatureText(feature.label, $event.target.value)" matInput aria-label="field-text">
                    </div>
                </div>

                <div class="feature-mobile">
                    <mat-form-field appearance="outline">
                        <mat-label>{{feature.label}}</mat-label>
                        <input matInput placeholder="" [value]="getFeatureValue(feature.label)" (blur)="saveFeatureText(feature.label, $event.target.value)">
                    </mat-form-field>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>

<div class="feature-actions desktop">
    <button (click)="addFeature()" mat-raised-button>Add additional feature</button>
</div>

<div class="feature-actions mobile">
    <button (click)="addFeatureMobile()" mat-raised-button>Add additional feature</button>
</div>
